import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { CardMenuIcon } from '../../../features/cardMenu';
import { usePlaylist, usePlaylistRemainingItemsAndProgress } from '../../../features/savedItems';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PlaylistCardTimeReadout } from '../PlaylistCardTimeReadout';
import SkeletonThumbnail from './SkeletonThumbnail';
import ThumbnailOverlayed from './ThumbnailOverlayed';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistThumbnailOverlayed = ({
  playlistId,
  isGhost,
  disableGradient,
  centerContent,
  renderMenu = menu => menu,
  header
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const {
    status,
    remainingProgressItemCount,
    totalProgressItemCount
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const completed = status === FILTER_CONSTS.STATUSES.COMPLETED;
  const showProgress = status && status !== FILTER_CONSTS.STATUSES.NOT_STARTED;
  if (!playlist) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }
  const {
    thumbnailRectangleUrl
  } = playlist;
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    completed: completed,
    disableGradient: disableGradient,
    header: header,
    headerIcons: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
      playlistId: playlistId,
      use: "on-dark"
    })),
    isGhost: isGhost,
    previewThumbnailRectangleUrl: thumbnailRectangleUrl || undefined,
    remainingTime: showProgress ? remainingProgressItemCount : undefined,
    thumbnailCenter: centerContent,
    thumbnailFooter: !completed && /*#__PURE__*/_jsx(PlaylistCardTimeReadout, {
      playlistId: playlistId
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.playlists.playlist`
    }),
    totalTime: showProgress ? totalProgressItemCount : undefined
  });
};
export default PlaylistThumbnailOverlayed;